var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProDialog',{ref:"proDialogRef",attrs:{"title":'新增买粮人',"labelPosition":"top","fields":_vm.fields,"formData":_vm.buyerForm,"rules":_vm.rules,"width":'500px',"labelWidth":"110px","onConfirm":_vm.handleConfirm},on:{"update:formData":function($event){_vm.buyerForm=$event},"update:form-data":function($event){_vm.buyerForm=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }